import { getStripePayments } from "@stripe/firestore-stripe-payments"
import { app } from "../firebase/index"

export const paymentsInstance = getStripePayments(app, {
    productsCollection: "products",
    customersCollection: "users"
})

export const APPSUMO_PRICE_ID = "price_1MV231GOGhxZLaYPbr6oks4f"
export const ANNUAL_PRICE_ID = "price_1MV4SnGOGhxZLaYPtJGVNW9o"
export const MONTHLY_PRICE_ID = "price_1MV4qBGOGhxZLaYPE7kpRuvM"

export const MONTHLY_PRICE_ID_19USD = "price_1Mrh8AGOGhxZLaYPv32dsIav"
export const ANNUAL_PRICE_ID_19USD = "price_1Mrh7hGOGhxZLaYPt9l9Q72s"

export const PROMO_CODES = {
    smma3months: "promo_1MrJDNGOGhxZLaYPD7YgHqLy",
    smma1month: "promo_1MrmAsGOGhxZLaYPWjASBVNb",
    email3months30percent: "promo_1Mo8J0GOGhxZLaYPZWq1S9XW"
}
